import type { TUser } from './user';
import type { TOrganization } from './organization';
import type { TMember } from './member';
import type { ValueOf } from './utilities';

export const INTERVIEWER_TYPES = {
  external: 'EXTERNAL',
  member: 'MEMBER',
} as const;

export type TInterviewer = {
  id: number;
  avatar: string;
  organization: TOrganization;
  created_by: TUser;
  created_at: string;
  updated_at: string;
  name: string;
  email: string;
  job_title: string;
  company_name: string;
  member: TMember;
  type: ValueOf<typeof INTERVIEWER_TYPES>;
};
